import {
  Button,
  Table,
  Typography,
  Popconfirm,
  InputNumber,
  Flex,
  Row,
  Col,
  Select,
  Dropdown,
  Input,
  Card,
  Form,
  DatePicker,
} from "antd";
import { PlusOutlined, DeleteOutlined, DownOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { ServicetypeService } from "../../../Services/Manage/ServicetypeService";
import SubscriptionDropdown from "../../general/SubscriptionDropdown";
import dayjs from "dayjs";

const { Text } = Typography;

const GeneralExpenseAdd = ({
  dataSource,
  setDataSource,
  handleNewAdd,
  handleAdd,
  handleDelete,
  handleChange,
  setVendorId,
  vendorId,
  setPoId,
  setTaxId,
  setTaxType,
  taxId,
  taxType,
  editPO
}) => {
  const [vendorOption, setVendorOption] = useState([]);
  const [form] = Form.useForm();
  const [lastPO, setLastPO] = useState("");

  const lastAddedPO = async () => {
    try {
      const response = await ServicetypeService.lastAddedPO();
      const lastPOValue = response?.data;
      const newPO = generateNextPO(lastPOValue);
      setLastPO(newPO);
      setPoId(newPO);
      form.setFieldsValue({ po_id: newPO });
    } catch (error) {
      console.error("Error fetching last PO:", error);
      const newPO = generateNextPO(null);
      setLastPO(newPO);
      form.setFieldsValue({ po_id: newPO });
      setPoId(newPO);
    }
  };

  // console.log("+++", vendorId, taxId, taxType);

  useEffect(() => {
    form.setFieldsValue({
      vendor_id: vendorId,
      tax_id: taxId,
      tax_type: taxType,
    });
  }, [vendorId, taxId, taxType]);



  const GetAllVendors = async () => {
    try {
      const request = await ServicetypeService.getAllVendors();
      setVendorOption(
        request.data.map((item, index) => ({
          label: item.name,
          value: item.id,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

useEffect(() => {
  GetAllVendors();

  if (editPO) {
    // ✏️ Edit mode → use existing PO ID
    setLastPO(editPO.po_id);
    setPoId(editPO.po_id);
    form.setFieldsValue({ po_id: editPO.po_id });
  } else {
    // 🆕 Create mode → generate new PO ID
    lastAddedPO();
  }
}, [editPO]);


  const columns = [
    {
      title: "SI No",
      dataIndex: "key",
      width: "7%",
      align: "center",
      render: (_, __, index) => index + 1,
    },

    {
      title: "Description",
      dataIndex: "description",
      width: "30%",
      render: (text, record) => (
        <TextArea
          size="large"
          allowClear
          rows={2}
          value={text}
          onChange={(e) =>
            handleChange(record.id ?? record.key, "description", e.target.value)
          }
        />
      ),
    },
    {
      title: "Qty",
      dataIndex: "qty",
      width: "12%",
      align: "center",
      render: (text, record) => (
        <InputNumber
          min={0}
          size="large"
          value={text}
          onChange={(value) =>
            handleChange(record.id ?? record.key, "qty", value)
          }
        />
      ),
    },

    // {
    //   title: "Subscription",
    //   children: [
    //     {
    //       title: "Date",
    //       dataIndex: "expense_date",
    //       key: "expense_date",
    //       width: "10%",
    //       align: "center",
    //       render: (text, record) => (
    //         <DatePicker
    //           size="large"
    //           format="YYYY-MM-DD"
    //           value={text ? dayjs(text.split("T")[0]) : null}
    //           onChange={(date, dateString) =>
    //             handleChange(
    //               record.id ?? record.key,
    //               "expense_date",
    //               dateString
    //             )
    //           }
    //           style={{
    //             width: "100%",
    //             fontSize: 13,
    //             height: 28,
    //           }}
    //         />
    //       ),
    //     },
    //     // {
    //     //   title: "Subscription Type",
    //     //   dataIndex: "subscription_type",
    //     //   key: "subscription_type",
    //     //   width: "14%",
    //     //   align: "center",
    //     //   render: (text, record) => (
    //     //     <SubscriptionDropdown
    //     //       value={text}
    //     //       size="large"
    //     //       onChange={(val) =>
    //     //         handleChange(record.id ?? record.key, "subscription_type", val)
    //     //       }
    //     //     />
    //     //   ),
    //     // },
    //   ],
    // },

    {
      title: "Unit",
      dataIndex: "unit",
      width: "12%",
      align: "center",
      render: (text, record) => (
        <Input
          size="large"
          value={text}
          onChange={(e) =>
            handleChange(record.id ?? record.key, "unit", e.target.value)
          }
        />
      ),
    },
    {
      title: "Unit Price",
      dataIndex: "unitprice",
      width: "12%",
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="large"
          min={0}
          value={text}
          onChange={(value) =>
            handleChange(record.id ?? record.key, "unitprice", value)
          }
        />
      ),
    },
    {
      title: "tax (%)",
      dataIndex: "tax_amount",
      width: "12%",
      align: "center",
      render: (text, record) => (
        <InputNumber
          size="large"
          min={0}
          value={text}
          onChange={(value) =>
            handleChange(record.id ?? record.key, "tax_amount", value)
          }
        />
      ),
    },
    {
      title: "Total Price",
      dataIndex: "totalprice",
      align: "center",
      render: (text) => <Text>{text}</Text>,
      width: "10%",
    },
    {
      title: "Action",
      align: "center",
      width: 120,
      render: (_, record) => (
        <>
          <Button
            icon={<PlusOutlined />}
            type="dashed"
            size="large"
            style={{ marginRight: 8 }}
            onClick={() => handleAdd(record.id ?? record.key)}
          />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record)}
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </>
      ),
    },
  ];

  const generateNextPO = (lastPOValue) => {
    const now = new Date();

    // Today's ddyy (for PO prefix)
    const dd = String(now.getDate()).padStart(2, "0");
    const yy = String(now.getFullYear()).slice(-2);
    const todayDdyy = `${dd}${yy}`;

    console.log("lastPOValue?.po_id",lastPOValue?.po_id);
    
    // If no previous PO
    if (!lastPOValue?.po_id || !lastPOValue?.added_on) {
      return `PO-${todayDdyy}-001`;
    }

    const lastPoId = lastPOValue.po_id;

    // console.log("++---",lastPoId);
    

    // Extract number from last PO
    const match = lastPoId.match(/^PO-\d{4}-(\d{3})$/);
    if (!match) {
      return `PO-${todayDdyy}-001`;
    }

    const lastNumber = parseInt(match[1], 10);

    // Extract year from added_on
    const lastAddedOn = new Date(lastPOValue.added_on);
    const lastYear = lastAddedOn.getFullYear();
    const currentYear = now.getFullYear();

    // Same year → increment
    if (lastYear === currentYear) {
      const nextNumber = lastNumber + 1;
      return `PO-${todayDdyy}-${String(nextNumber).padStart(3, "0")}`;
    }

    // New year → reset counter
    return `PO-${todayDdyy}-001`;
  };

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        {/* <Row justify="space-between" align="middle">
          <Col>
            <Typography.Title level={4} style={{ margin: 0 }}>
              Purchase Order
            </Typography.Title>
          </Col>

          <Col>
            
          </Col>
        </Row> */}
      </div>

      <Card>
        <Form layout="vertical" form={form}>
          <Row gutter={16} align="bottom">

            {/* PO ID */}
            <Col span={8}>
              <Form.Item label="PO ID" name="po_id">
                <Input size="large" readOnly value={lastPO} />
              </Form.Item>
            </Col>

            {/* Vendor */}
            <Col span={8}>
              <Form.Item
                label="Select Vendor"
                name="vendor_id"
                rules={[{ required: true, message: "Please select a vendor" }]}
              >
                <Select
                  size="large"
                  value={vendorOption.find(v => v.value === Number(vendorId))}
                  placeholder="Choose Vendor"
                  options={vendorOption}
                  onChange={(value) => {
                    handleChange(null, "vendor_id", value);

                    setVendorId(value);
                  }}
                />
              </Form.Item>
            </Col>

            {/* Tax Type / Name */}
            <Col span={8}>
              <Form.Item
                label="Tax Type / Name"
                name="tax_type"

              >
                <Input
                  size="large"
                  placeholder="GST / IGST"
                  value={taxType}
                  onChange={(e) =>
                    handleChange(null, "tax_type", e.target.value)
                  }
                />
              </Form.Item>
            </Col>

            {/* Tax ID */}
            <Col span={8}>
              <Form.Item
                label="Tax ID"
                name="tax_id"

              >
                <Input
                  size="large"
                  value={taxId}
                  placeholder="Enter Tax ID"
                  onChange={(e) =>
                    handleChange(null, "tax_id", e.target.value)
                  }
                />
              </Form.Item>
            </Col>

            {/* Buttons */}
            <Col span={8}>

              <Form.Item
                label=" "
                name=" "
              >

                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    size="large"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={handleNewAdd}
                  >
                    Add Row
                  </Button>

                  <Button danger size="large" onClick={() => setDataSource([])}>
                    Clear
                  </Button>
                </div>
              </Form.Item>

            </Col>

          </Row>
        </Form>
      </Card>


      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        rowKey="key"
        // summary={() => {
        //   let totalQty = 0;
        //   let totalprice = 0;
        //   let tax =0;

        //   dataSource.forEach(({ qty, totalprice: rowTotal }) => {
        //     totalQty += qty || 0;
        //     totalprice += rowTotal || 0;
        //   });

        //   return (
        //     <Table.Summary.Row>
        //       <Table.Summary.Cell index={0} colSpan={2}>
        //         <Text strong>Total</Text>
        //       </Table.Summary.Cell>
        //       <Table.Summary.Cell index={2}>
        //         <Text strong>{totalQty}</Text>
        //       </Table.Summary.Cell>
        //       <Table.Summary.Cell index={3}></Table.Summary.Cell>
        //       <Table.Summary.Cell index={4}>
        //         <Text strong>{totalprice}</Text>
        //       </Table.Summary.Cell>
        //       <Table.Summary.Cell index={5}></Table.Summary.Cell>
        //     </Table.Summary.Row>
        //   );
        // }}
        summary={(data) => {
          let totalQty = 0;
          let subTotal = 0;
          let totalTax = 0;

          data.forEach(({ qty, unitprice, tax_amount }) => {
            const q = Number(qty) || 0;
            const price = Number(unitprice) || 0;
            const taxPercent = Number(tax_amount) || 0;

            const rowSubTotal = q * price;
            const rowTax = (rowSubTotal * taxPercent) / 100;

            totalQty += q;
            subTotal += rowSubTotal;
            totalTax += rowTax;
          });

          const grandTotal = subTotal + totalTax;

          return (
            <Table.Summary align="right">
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={7}>
                  <div style={{ textAlign: "right" }}>
                    <Typography.Text strong>
                      Total Qty: {totalQty}
                    </Typography.Text>
                  </div>
                </Table.Summary.Cell>
              </Table.Summary.Row>

              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={7}>
                  <div style={{ textAlign: "right" }}>
                    <Typography.Text strong>
                      Sub Total: {subTotal.toFixed(2)}
                    </Typography.Text>
                  </div>
                </Table.Summary.Cell>
              </Table.Summary.Row>

              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={7}>
                  <div style={{ textAlign: "right" }}>
                    <Typography.Text strong>
                      Total Tax: {totalTax.toFixed(2)}
                    </Typography.Text>
                  </div>
                </Table.Summary.Cell>
              </Table.Summary.Row>

              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={7}>
                  <div style={{ textAlign: "right" }}>
                    <Typography.Text strong>
                      Grand Total: {grandTotal.toFixed(2)}
                    </Typography.Text>
                  </div>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>

          );
        }}
      />
    </>
  );
};

export default GeneralExpenseAdd;
